<script setup lang="ts">
import EditAuthMemberDrawer from '@/pages/erp/ds/auth/view/ds-authMember-drawer.vue'
import type { AuthMemberProperties } from '@/pages/erp/ds/auth/db/ds-authMember-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DSAUTHMEMBER',
    },
})

const compId = ref(useStorage('compNo').value)
const authorityId = ref()
const action = ref()
const member = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '操作動作', key: 'action' },
    { title: '成員代號', key: 'member' },
    { title: '成員類別', key: 'memberType' },
    { title: '存取權限', key: 'accessControl' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: authMembersData, execute: fetchAuthMembers } = await useApi<any>(createUrl('/ds/auth/authMember/searchAuthMember', {
  query: {
    compId,
    authorityId,
    action,
    member,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): AuthMemberProperties[] => authMembersData.value.data.authMemberPage.content)
const totalDatas = computed(() => authMembersData.value.data.authMemberPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (authMemberData: AuthMemberProperties) => {
  voData = authMemberData
  console.log('editAuthMember: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (authMemberData: AuthMemberProperties) => {
    voData = authMemberData
    console.log('copyAuthMember: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (authMemberData: AuthMemberProperties) => {
  await $api('/ds/auth/authMember/createAuthMember', {
    method: 'POST',
    body: { authMember: authMemberData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchAuthMembers()
}

const updateData = async (authMemberData: AuthMemberProperties) => {
  await $api('/ds/auth/authMember/updateAuthMember', {
    method: 'PUT',
    body: { authMember: authMemberData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchAuthMembers()
}

  // 👉 Delete data
const deleteData = async (authMemberData: AuthMemberProperties) => {
  const { compId,authorityId,action,member } = authMemberData
    $swal({
    title: `確定要刪除 ${authMemberData.member} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/auth/authMember/deleteAuthMember`, {
        method: 'DELETE',
        query: {
          compId,authorityId,action,member
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchAuthMembers()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="compId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入公司別"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="authorityId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入授權代碼"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="action"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入操作動作"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="member"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入成員代號"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增細部授權群組成員
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.action="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.action }}
          </div>
      </template>

      <template #item.member="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.member }}
          </div>
      </template>

      <template #item.memberType="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.memberType }}
          </div>
      </template>

      <template #item.accessControl="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.accessControl }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditAuthMemberDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :authMember-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
